/** 与后端 hasPermission 对齐：platform:* 仅匹配 platform: 前缀 */
export function hasPermission(holding: string[], code: string): boolean {
  if (!holding?.length) return false;
  if (holding.includes(code)) return true;
  if (
    code === 'platform:tenant:view' &&
    holding.includes('platform:tenant:manage')
  ) {
    return true;
  }
  if (holding.includes('platform:*') && code.startsWith('platform:')) return true;
  const parts = code.split(':');
  if (parts.length >= 2) {
    const wild = `${parts[0]}:${parts[1]}:*`;
    if (holding.includes(wild)) return true;
  }
  return false;
}

export function hasAnyPermission(holding: string[], codes: string[]): boolean {
  return codes.some((c) => hasPermission(holding, c));
}
